import SettingsPost from './SettingsPost'

export default SettingsPost
